/** @type {import('../schema').ProcessDefinition} */
const cierreAprobacion = {
  id: "cierre-aprobacion",
  name: "Revisión, aprobación y publicación del cierre",
  category: "finanzas",
  outcome:
    "El Administrador valida la distribución del cierre y, al aprobar, publica las cuentas a los residentes.",
  trigger: "Existe un cierre con state: ok y approvalStatus: pending.",
  actors: ["Administrador", "Sistema", "Residente"],
  status: "COMPLETO",
  description:
    "Revisión del detalle de un cierre calculado y su aprobación, que publica payments y expensesapartments a los residentes.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    {
      id: "s1",
      laneId: "sys",
      type: "start",
      label: "Listado de cierres pendientes",
      description:
        "Muestra los cierres a revisar: período, alta y quién lo generó.",
      evidence: "src/screens/admin/CierreRevision.jsx",
    },
    {
      id: "s2",
      laneId: "admin",
      type: "task",
      label: "Revisión del detalle",
      description:
        "Tres vistas: metadatos, gastos del período y distribución por residente. Controla que los totales cuadren.",
    },
    {
      id: "s3",
      laneId: "admin",
      type: "decision",
      label: "¿Los totales cuadran y se aprueba?",
      description:
        "El Administrador decide aprobar o descartar según el cuadre con los gastos.",
    },
    {
      id: "s4",
      laneId: "admin",
      type: "task",
      label: "Aprobación y publicación",
      description:
        "Marca payments y expensesapartments como publishedToResidents: true, fija los cargos de amenities como incluidos y deja el cierre approvalStatus: approved con quién/cuándo.",
      evidence: "src/utils/cierreApprove.js, src/utils/cierrePublicacion.js",
    },
    {
      id: "s5",
      laneId: "sys",
      type: "handoff",
      label: "Persistencia y publicación a residentes",
      description:
        "Persiste el cambio de estado y hace visibles las cuentas a los residentes.",
    },
    {
      id: "s6",
      laneId: "res",
      type: "notification",
      label: "Cuentas visibles al residente",
      description:
        "El residente ve sus cuentas publicadas en Cuentas/Expensas.",
    },
    {
      id: "s7",
      laneId: "res",
      type: "end",
      label: "Cierre publicado",
    },
    {
      id: "s8",
      laneId: "admin",
      type: "end",
      label: "Cierre descartado",
      description:
        "Para corregir hay que eliminar y recalcular; el cierre aprobado no es reversible por UI.",
    },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4", label: "Aprobar" },
    { from: "s3", to: "s8", label: "Descartar" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
  ],
};
export default cierreAprobacion;
